import { css, html, LitElement, type PropertyValues } from 'lit';
import { property } from 'lit/decorators/property.js';

export class CartFooterTableComponent extends LitElement {
  @property({ type: String, attribute: 'total-label' })
  totalLabel = 'Total';

  @property({ type: String, attribute: 'initial-total-price' })
  initialTotalPrice = '0';

  protected override firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
  }

  protected override render() {
    return html`
      <table>
        <tr>
          <th>${this.totalLabel}</th>
          <td>${this.initialTotalPrice}</td>
        </tr>
      </table>
    `;
  }

  static override get styles() {
    return [
      css`
        table {
          width: 100%;
        }

        th {
          text-align: left;
        }
        td {
          text-align: right;
          font-variant: tabular-nums;
        }
      `,
    ];
  }
}

export function defineCartFooterTableComponent(): void {
  if (!customElements.get('y-cart-footer-table')) {
    customElements.define('y-cart-footer-table', CartFooterTableComponent);
  }
}
